import { render } from "./Footer.vue?vue&type=template&id=5e2af6ca&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=5e2af6ca&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Danka\\Desktop\\VUE PORTAL\\portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e2af6ca"]])

export default __exports__